import { useParams } from 'react-router-dom';

import { Icon } from '../../../components/icon';
import { useGetCase } from '@/api/queries/useGetCase';
import { Breadcrumb } from '@/new/components/breadcrumb';
import { PageContainer } from '@/new/components/page-container';
import { PageHeader } from '@/new/components/page-header';
import { PageTitle } from '@/new/components/page-title';
import { Button } from '@/new/components/shadcn/button';

export function DocumentsExplorer() {
  const { matterId } = useParams();
  if (!matterId) return;

  const { isLoading: isLoadingCase, data: caseData, refetch: refetchCase, error: caseError } = useGetCase(matterId);

  return (
    <>
      <Breadcrumb
        items={
          caseData
            ? [
                { href: '/matters', label: 'Matters', active: false },
                {
                  href: `/matters/${caseData.id}`,
                  label: caseData.name,
                  active: true,
                },
              ]
            : [{ href: '/matters', label: 'Matters', active: false }]
        }
      />

      <PageContainer>
        {/* TODO: skeleton loading state */}
        <PageHeader>
          {caseData ? (
            <>
              <PageTitle text="Documents Explorer" />
              <Button variant="primary">
                <Icon className="lucide--file-plus" />
                Upload New Documents
              </Button>
            </>
          ) : null}
        </PageHeader>
      </PageContainer>
    </>
  );
}
